import { SystemEvents } from '@repo/alt/Services/constants/SystemEvents.js'
import type { CartProductListItemDto, OrderDto } from '@repo/api/web/models'
import { injectable } from 'inversify'
import type { Emitter } from 'nanoevents'

import { LocalStorageProvider } from '#Common/support'
import { useOrderStore } from '#Order/store'

@injectable()
export class OrderSupport {
  protected static STORAGE_KEY = 'order_selected_items'

  protected bus: Emitter
  protected store: ReturnType<typeof useOrderStore>
  protected storage: LocalStorageProvider

  constructor() {
    this.bus = useBus()
    this.store = useOrderStore()
    this.storage = new LocalStorageProvider()
  }

  emitOrderCreated(order?: OrderDto) {
    this.bus.emit(SystemEvents.ORDER_CREATED, order)
  }

  loadItemsForOrder() {
    const items = this.storage.get(OrderSupport.STORAGE_KEY)
    if (items) {
      this.store.setSelectedItemsForOrder(items)
    }
  }

  saveItemsForOrder(items: CartProductListItemDto[]) {
    this.storage.set(OrderSupport.STORAGE_KEY, items)
    this.store.setSelectedItemsForOrder(items)
  }

  clearItemsForOrder() {
    this.storage.set(OrderSupport.STORAGE_KEY, [])
    this.store.setSelectedItemsForOrder([])
  }
}
